module.exports = __webpack_public_path__ + "static/media/bytt-nn-18.93409408.mp3";